module.exports = __webpack_public_path__ + "static/group3_1-6d21c718981e6dda1e98d08e85742d6a.webp";